// @flow

import cloneDeep from "lodash/cloneDeep";
import merge from "lodash/merge";
import { type AxiosRequestConfig } from "axios";
import { type Store } from "redux";

import { getAuthToken } from "../utils/auth";

type AxiosEnhancer = (config: AxiosRequestConfig) => AxiosRequestConfig;

export const enhance =
  (...enhancers: AxiosEnhancer[]) =>
  (baseConfig: AxiosRequestConfig) =>
    enhancers.reduce((prevEnhancer, nextEnhancer) => args => nextEnhancer(prevEnhancer(args)))(
      baseConfig
    );

const mergeConfigs = (object: AxiosRequestConfig, source: AxiosRequestConfig) => {
  const clone = cloneDeep(object);
  merge(clone, source);
  return clone;
};

export const authenticate: AxiosEnhancer =
  (store: Store<any, any>, persistKey = null) =>
  baseConfig => {
    const token = getAuthToken(store, persistKey);

    return token
      ? mergeConfigs(baseConfig, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
      : baseConfig;
  };

// In enhancer do this token validation as middleware
